export const itemsGridFields = ({ dropDowns }) => [
  {
    id: "itemNumber",
    name: "itemNumber",
    label: "item Num",
    disabled: true,
  },
  {
    id: "materialId",
    name: "materialId",
    label: "Material",
    tag: "select",
    options: dropDowns?.materials || [],
  },

  {
    id: "quantity",
    name: "quantity",
    label: "Quantity",
  },
  {
    id: "unitId",
    name: "unitId",
    label: "Unit",
    tag: "select",
    options: dropDowns?.qtyUnits || [],
  },
];

